import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { faqs } from '../data/faqData';
interface MiniFAQProps {
  category: string;
  title?: string;
}
export function MiniFAQ({
  category,
  title = 'Veelgestelde vragen'
}: MiniFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const filteredFaqs = faqs.filter(faq => faq.category === category);
  if (filteredFaqs.length === 0) return null;
  return <section className="py-12" data-id="element-222">
      <h2 className="text-xl md:text-2xl font-bold mb-6" data-id="element-223">{title}</h2>
      <div className="space-y-3" data-id="element-224">
        {filteredFaqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-225">
              <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 transition-colors duration-150 focus:outline-none" data-id="element-226">
                <span className="font-medium text-gray-900 pr-4 text-sm" data-id="element-227">
                  {faq.question}
                </span>
                <ChevronDown size={18} className={`text-gray-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-228" />
              </button>
              {isOpen && <div className="px-4 pb-4 text-sm text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-229">
                  {faq.answer}
                </div>}
            </div>;
      })}
      </div>
      <div className="mt-4" data-id="element-230">
        <Link to="/faq" className="text-sm text-gray-500 hover:text-gray-900 hover:underline" data-id="element-231">
          Bekijk alle veelgestelde vragen →
        </Link>
      </div>
    </section>;
}